import React, { useState } from 'react';
import open from '../../images/icons/open.svg'
import close from '../../images/icons/close.svg'
import check from '../../images/icons/check.svg'
import Advert from '../../components/advert';

function PricingBody(props) {
    let def_mth_price = 85
    let def_year_price = 980
    let silver = 85
    let silverNGN = '7,000'
    let gold = 210
    let goldNGN = '18,000'
    let platinum = 720
    let platinumNGN = '60,000'
    let currency = 'R'
    const [current, setCurrent] = useState(1)
    const [plans, setPlans] = useState([{
        plan:"Experience",price:0,ngnprice:0,period:'', 
        features:[
            'Free plan which comes as a default when you sign up with YeboKenny',
            'Limited access to basic features',
            'Basic analytics dashboard for profile views',
            'Explore platform capabilities before commitment'
        ]
    },
    {
        plan:"Silver",price:silver,ngnprice:silverNGN,period:'per month',
        features:[
            'View Recommendation Details',
            'Add Business Gallery',
            'Add Business Hours',
            'Priority listing in search results',
            'Customer engagement tools (respond to reviews/messages)'
        ]
    },
    {
        plan:"Gold",price:gold,ngnprice:goldNGN,period:'per quarter',  
        features:[
            'View Recommendation Details',
            'Add Multiple Businesses',
            'Add Business Gallery',
            'Add Business Hours',
            'Enhanced analytics (customer demographics, engagement trends)',
            'Promotional tools to create and manage special offers'
        ]
    },
    {
        plan:"Platinum",price:platinum,ngnprice:platinumNGN,period:'per year', 
        features:[
            'All features in Gold Plan',
            'Dedicated account support',
            'Advanced advertising options (discounts for premium placements)',
            'Exclusive access to beta features',
            'Priority customer support'
        ]
    },
])

    const [currentFaq, setCurrentFaq] = useState()
    const [faqs, setFaqs] = useState([
        {id:1,question:'Is there free trial available',answer:'There is an option to set up a free account, however you will be limited in functionalities usage'},
        {id:2,question:'Can I change my plan later?',answer:'You can always upgrade or downgrade your plan anytime, terms and conditions apply.'}
    ])

    const changeFaq = (faq) => {
        if(currentFaq == faq) setCurrentFaq(0)
        else setCurrentFaq(faq)
    }
    return (
        <div className='flex flex-col'>
            <div className="bg-[url('images/pricingHero.svg')] py-10">
                <div className='flex flex-col items-center text-center py-20 text-white'>
                    <div className='text-[32px] lg:text-[60px] font-[500]'>Pricing plans</div>
                    <div className='text-[18px] lg:text-[24px] mt-4'>Simple, transparent pricing that grows with you.</div>
                    <div className='mt-10'>
                        <div className='rounded-[30px] border-[1px] h-[60px] flex flex-row items-center space-x-3 py-3 px-2'>
                            <span onClick={() => setCurrent(1)} className={`${current == 1 ? 'bg-white text-[#008B39]' : 'text-white'} h-[50px] rounded-[24px] grid px-3 cursor-pointer`}>
                                <span className='my-auto text-[16px] font-[500]'>NGN</span>
                            </span>
                            <span onClick={() => setCurrent(2)} className={`${current == 2 ? 'bg-white text-[#008B39]' : 'text-white'} h-[50px] rounded-[24px] grid px-3 cursor-pointer`}>
                                <span className='my-auto text-[16px] font-[500]'>ZAR</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='grid grid-cols-6 px-10 lg:px-20 lg:gap-x-5 gap-y-5 lg:gap-y-0 mt-[-40px] mb-10'>
                {plans.map(({plan,ngnprice,price,features,period}) => {
                    return (
                        <div className='col-span-6 lg:col-span-2 rounded-[16px] p-4 flex flex-col shadow-md bg-white mb-5'>
                            <div className='h-[350px]'>
                                <div className='flex flex-row justify-between'>
                                    <span className=''>{plan} plan</span>
                                    <span>{plan != 'Gold'? '' : <span className='bg-[#F1FFF7] text-[#008B39] p-2 rounded-[16px]'>Popular</span>}</span>
                                </div>
                                <div className='flex flex-row'>
                                    <span className='text-[42px] font-[600]'>{current == 1 ? 'NGN' : 'R'} {current == 1 ? ngnprice : price}</span>
                                    <span className='mt-[50px]'>{!period ? 'for 14 days' : period}</span>
                                </div>
                                <hr className='my-3'/>
                                <div className='flex flex-col space-y-2'>
                                    {features.map((item) => {
                                        return (
                                            <div className='grid grid-cols-8 items-start '>
                                                <span className='col-span-1'><img className='w-[20px] h-[20px]' src={check} /></span>
                                                <span className='col-span-7 text-start'>{item}</span>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <hr className='my-8'/>
                            <a href='https://portal.yebokenny.com/register' className='mb-5 cursor-pointer grid bg-[#008B39] text-white h-[50px] items-center rounded-[8px]'>
                                <span>Get started</span>
                            </a>
                        </div>
                    )
                })}
            </div>
            <div className='grid grid-cols-8 px-10 lg:px-20 py-10 lg:py-20 items-start lg:gap-x-20'>
                <div className='col-span-8 lg:col-span-3 flex flex-col text-start'>
                    <span className='font-[500] text-[32px] lg:text-[48px]'>FAQs</span>
                    <span className='text-[#667085] text-[18px]'>Everything you need to know about the product and billing.</span>
                </div>
                <div className='col-span-8 lg:col-span-5 lg:space-y-10'>
                    {faqs.map(({id,question,answer}) => {
                        return (
                            <div className={`${id == currentFaq ? 'bg-[#F9FAFB] rounded-[8px]' : ''} p-3 flex flex-col`}>
                                <div className='flex flex-row justify-between'>
                                    <span className='text-[#101828] font-[500] text-[18px]'>{question}</span>
                                    <span className='cursor-pointer' onClick={() => changeFaq(id)}><img src={id == currentFaq ? close : open} /></span>
                                </div>
                                <div className={`${id == currentFaq ? '' : 'hidden'} text-[#667085] font-[400] text-[18px] text-start`}>{answer}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className='px-10 lg:px-20 pb-20'>
                <Advert></Advert>
            </div>
        </div>
    );
}

export default PricingBody;